import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Grid, Typography, TextField, Button, RadioGroup, FormControlLabel, Radio, MenuItem, CircularProgress, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { enviarDadosAction, limparDadosEnvioPagamento, salvarPlanoAction, assinaturaTransacaoIDAction, enviarAssinaturaTransacaoID, verificarCupomStart } from '../../store/reducers/utils';
import { formatValor } from '../../services/utils.js';
import CustomizedSteppers from '../../components/IndicativoFluxo';
import ButtonReturn from '../../components/ButtonReturn/ButtonReturn';
import AlertError from '../../components/AlertError.jsx/AlertError';
import { trocarPlano } from '../../store/reducers/plano'

function Pagamento() {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const ID_GATEWAY_PIX = 'be246a0c-b9f0-11ec-8725-1c1bb54b8682'
    const ID_GATEWAY = '8a04d1a6-128a-11ed-ab9c-12d2147dce0f'
    const dadosCadastro = useSelector(state => state.utils?.dadosCadastro);
    const planoSelecionado = useSelector(state => state.plano.planoSelecionado);
    const opcaoSelecionada1 = useSelector(state => state.plano.opcaoSelecionada);
    const respostaEnviar = useSelector(state => state.utils?.respostaEnviar);
    const assinaturaTransacaoIDStore = useSelector(state => state.utils.assinaturaTransacaoID);
    const respostaTroca = useSelector(state => state.plano.respostaTroca);
    const erroTroca = useSelector(state => state.plano.errorTroca);
    const cupom = useSelector(state => state.utils.cupom);
    const [formaPagamentoAtual, setFormaPagamentoAtual] = useState(() => {
        if (opcaoSelecionada1?.formasPagamento?.[0]?.formaPagamentoID === ID_GATEWAY ||
            opcaoSelecionada1?.formasPagamento?.[0]?.formaPagamentoID === ID_GATEWAY_PIX) {
            return opcaoSelecionada1?.formasPagamento?.[0];
        } else {
            return { id: 0, nome: '', numeroParcelas: 0, valorFinal: 0 };
        }
    });

    const [idPagamento, setIdPagamento] = useState(
        opcaoSelecionada1?.formasPagamento?.[0]?.formaPagamentoID || null
    );

    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [mesSelecionado, setMesSelecionado] = useState('');
    const [prosseguir, setProsseguir] = useState(false)
    const [formState, setFormState] = useState({
        planoAssinaturaOpcaoPagamentoID: '',
        cupomDesconto: '',
        numeroCartao: '',
        nomeTitular: '',
        mesCartao: '',
        anoCartao: '',
        codigoCartao: '',
        dataNascimento: '',
    });
    const [dateFocused, setDateFocused] = useState(false);
    const [dataNascimento, setDataNascimento] = useState('');
    const [loading, setLoading] = useState(false);
    const arrayParcelas = opcaoSelecionada1.formasPagamento?.filter(forma => forma.formaPagamentoID === ID_GATEWAY);
    const currentYear = useRef(new Date().getFullYear());
    const mesesDoAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    const radioFormasPagamento = {
        temPix: !!opcaoSelecionada1.formasPagamento?.find(forma => forma.formaPagamentoID === ID_GATEWAY_PIX),
        temCartao: !!opcaoSelecionada1.formasPagamento?.find(forma => forma.formaPagamentoID === ID_GATEWAY),
    }
    const ehFreemium = useSelector(state => state.utils.ehFreemium);
    const assinaturaID = useSelector(state => state.plano?.assinaturaAntiga);
    const cupomInfo = useSelector(state => state.utils?.cupomInfo);
    const dadosAntigo = useSelector(state => state.plano?.dadosUsuario?.dados);



    useEffect(() => {
        if (Object?.keys(dadosCadastro || dadosAntigo?.lista)?.length === 0) {
            navigate('/cadastro')
        }
        setOpenAlert(false)
        setMessageAlert('')
    }, [])


    const compararFormaPagamentoID = (id) => {
        if (id.toUpperCase() === ID_GATEWAY.toUpperCase()) {
            setIdPagamento(ID_GATEWAY)
        } else if (id.toUpperCase() === ID_GATEWAY_PIX.toUpperCase()) {
            setIdPagamento(ID_GATEWAY_PIX)
        } else {
            console.log('ID inválio e/ou não encontrado. ID: ', id);
        }
    }

    useEffect(() => {
        dispatch(verificarCupomStart({ codigo: cupom, planoAssinaturaOpcaoPagamentoID: opcaoSelecionada1?.formasPagamento?.[0]?.planoAssinaturaOpcaoPagamentoID }));
    }, [])

    const handleMetodoPagamento = ({ target }) => {

        if (target.value !== null) compararFormaPagamentoID(target.value)
    };

    useEffect(() => {
        setFormaPagamentoAtual(opcaoSelecionada1.formasPagamento?.filter(forma => forma.formaPagamentoID === idPagamento)[0])
    }, [idPagamento])

    const dinamicSetFormState = (name, value) => {
        setFormState((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleFormState = (e) => {
        const { name, value } = e.target;
        dinamicSetFormState(name, value)
    };

    const handleBlur = (e) => {
        const { name } = e.target;
        dinamicSetFormState(`${name}Tocado`, true)
    };

    useEffect(() => {
        if (!formaPagamentoAtual) return;

        setFormState((prevFormState) => ({
            ...prevFormState,
            parcelas: formaPagamentoAtual.numeroParcelas,
            planoAssinaturaOpcaoPagamentoID: formaPagamentoAtual.planoAssinaturaOpcaoPagamentoID,
        }));
    }, [formaPagamentoAtual]);

    useEffect(() => {
        const mes = mesesDoAno.indexOf(mesSelecionado) === -1 ? '' : mesesDoAno.indexOf(mesSelecionado) + 1
        dinamicSetFormState('mesCartao', mes)
    }, [mesSelecionado])

    const formatCardNumber = (value) => {
        const onlyDigits = value.replace(/\D/g, '').slice(0, 16);
        const formattedValue = onlyDigits.replace(/(\d{4})(?=\d)/g, '$1 ')
        return formattedValue.trim();
    };

    const handleCardNumberChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = formatCardNumber(value);
        dinamicSetFormState(name, formattedValue);
    };

    const handleDataNascimentoChange = (e) => {
        const { name, value } = e.target;
        const [year, month, day] = value.split('-');
        const date = `${day}/${month}/${year}`;
        dinamicSetFormState(name, value); // Valor que estará no input (aaaa-mm-dd)
        setDataNascimento(date) // Valor que será enviado no input (dd/mm/aaaa)
    };

    const handleParcelas = ({ target }) => {
        const obj = opcaoSelecionada1.formasPagamento?.find(forma => forma.planoAssinaturaOpcaoPagamentoID === target.value)
        setFormaPagamentoAtual(obj)
    }

    // Validação para o número do cartão de crédito
    const numeroCartaoError =
        (formState.numeroCartaoTocado && formState.numeroCartao === '') ||
        (formState.numeroCartaoTocado && !/^(\d{4}\s?){3}\d{4}$/.test(formState.numeroCartao));

    // Validação para o nome do titular do cartão
    const nomeTitularError =
        (formState.nomeTitularTocado && formState.nomeTitular === '') ||
        (formState.nomeTitularTocado && formState.nomeTitular.length < 2) ||
        (formState.nomeTitularTocado && !/^[\p{L}\s]+$/u.test(formState.nomeTitular));

    // Validação para o mês de expiração do cartão
    const mesCartaoError =
        (formState.mesCartaoTocado && formState.mesCartao === '') ||
        (formState.mesCartaoTocado && formState.mesCartao.length > 0);

    // Validação para o ano de expiração do cartão
    const anoCartaoError =
        (formState.anoCartaoTocado && formState.anoCartao === '') ||
        (formState.anoCartaoTocado && (!/^\d{4}$/.test(formState.anoCartao) ||
            (parseInt(formState.anoCartao, 10) < currentYear.current) || (parseInt(formState.anoCartao, 10) > currentYear.current + 20)));

    // Validação para o código de segurança do cartão (CVV)
    const codigoCartaoError =
        (formState.codigoCartaoTocado && formState.codigoCartao === '') ||
        (formState.codigoCartaoTocado && !/^\d{3}$/.test(formState.codigoCartao));

    // Validação para a data de nascimento
    const dataNascimentoError =
        (formState.dataNascimentoTocado && formState.dataNascimento === '') ||
        (formState.dataNascimentoTocado && !/^\d{4}-\d{2}-\d{2}$/.test(formState.dataNascimento)) ||
        (formState.dataNascimentoTocado && formState.dataNascimento < '1900-01-01') ||
        (formState.dataNascimentoTocado && formState.dataNascimento > new Date().toISOString().slice(0, 10));

    useEffect(() => {
        const errors = {
            // cupomDesconto: formState.cupomDesconto,
            cartaoNumero: numeroCartaoError || formState.numeroCartao === '' || formState.numeroCartao < 16,
            cartaoNome: nomeTitularError || formState.nomeTitular === '' || formState.nomeTitular.length < 2,
            cartaoMesValidade: mesCartaoError || formState.mesCartao === '',
            cartaoAnoValidade: anoCartaoError || formState.anoCartao === '',
            codigoCartao: codigoCartaoError || formState.codigoCartao === '' || formState.codigoCartao.length < 3,
            cartaoDataNascimento: dataNascimentoError || formState.dataNascimento === '',
        }

        switch (formaPagamentoAtual.formaPagamentoID) {
            case ID_GATEWAY:
                setProsseguir(Object.values(errors).every(error => error === false))
                break
            case ID_GATEWAY_PIX:
                setProsseguir(true)
                break;
            default:
                setFormaPagamentoAtual(false)
        }
    }, [formState, formaPagamentoAtual])

    const pagarPlano = () => {
        const { sucesso, mensagem, copiaCola, pagamentoOk, assinaturaTransacaoID } = respostaEnviar;
        console.log(sucesso, mensagem, copiaCola, pagamentoOk, assinaturaTransacaoID);
        setLoading(false)
        if (sucesso === undefined) {
            setOpenAlert(true)
            setMessageAlert(mensagem)
            return
        }
        if (!sucesso) {
            setOpenAlert(true)
            setMessageAlert(mensagem)
            dispatch(limparDadosEnvioPagamento())
        } else if (sucesso) {
            if (pagamentoOk) {
                navigate('/finalizar');
            } else if (copiaCola !== null && copiaCola !== false) {
                navigate('/checkoutpix');
            } else if (assinaturaTransacaoID) {
                // Se sucesso ok, não está pago, não tem copia e cola, faz requisição em outro endpoint
                setOpenAlert(true)
                setMessageAlert('Pagamento não efetuado. Tente novamente.')
                dispatch(assinaturaTransacaoIDAction(assinaturaTransacaoID))
            } else {
                console.log('Erro ao enviar o pagamento');
                console.log('RespotaEnviar', respostaEnviar);
            }
        }
    }

    useEffect(() => {
        if (respostaTroca) {
            if (respostaTroca?.sucesso === undefined) {
                setOpenAlert(true)
                setMessageAlert(respostaTroca?.mensagem)
                return
            }
            if (!respostaTroca?.sucesso) {
                setOpenAlert(true)
                setMessageAlert(respostaTroca?.mensagem)
                dispatch(limparDadosEnvioPagamento())
            } else if (respostaTroca?.sucesso) {
                if (respostaTroca?.pagamentoOk) {
                    navigate('/finalizar');
                } else if (respostaTroca?.copiaCola !== null && respostaTroca?.copiaCola !== false) {
                    navigate('/checkoutpix');
                } else if (respostaTroca?.assinaturaTransacaoID) {
                    setOpenAlert(true)
                    setMessageAlert('Pagamento não efetuado. Tente novamente.')
                    dispatch(assinaturaTransacaoIDAction(respostaTroca?.assinaturaTransacaoID))
                } else {
                    console.log('Erro ao enviar o pagamento');
                    console.log('RespotaEnviar', respostaEnviar);
                }
            }
        }
    }, [respostaTroca]);

    useEffect(() => {
        setLoading(false);

        if (respostaEnviar && Object.keys(respostaEnviar).length > 0 && !assinaturaID) {
            pagarPlano();
        }
    }, [respostaEnviar]);


    const handleClickPagar = () => {
        setLoading(true)

        let dadosFinais = {}
        if (assinaturaTransacaoIDStore) {
            dadosFinais.assinaturaTransacaoID = assinaturaTransacaoIDStore
        } else if (!assinaturaTransacaoIDStore) {
            dadosFinais = {
                ...dadosCadastro,
                assinatura: {
                    planoAssinaturaOpcaoPagamentoID: formaPagamentoAtual.planoAssinaturaOpcaoPagamentoID,
                }
            }
        }

        if (idPagamento === ID_GATEWAY) {
            // Apenas adiciona os Dados do cartão caso seja pagamento por cartão
            const dadosCartao = {
                cartaoNumero: formState.numeroCartao,
                cartaoNome: formState.nomeTitular,
                cartaoMesValidade: formState.mesCartao,
                cartaoAnoValidade: formState.anoCartao,
                cartaoCodigo: formState.codigoCartao,
                cartaoDataNascimento: dataNascimento,
            }
            dadosFinais.assinatura = {
                ...dadosFinais.assinatura,
                ...dadosCartao
            }
            dadosFinais.endereco = { ...dadosCadastro.endereco }
        }

        const planoAssinaturaOpcaoPagamentoID = formState?.planoAssinaturaOpcaoPagamentoID

        if (assinaturaID) {
            if (formaPagamentoAtual.formaPagamento === 'Gateway PIX') {
                dispatch(
                    trocarPlano({
                        assinaturaID,
                        planoAssinaturaOpcaoPagamentoID,
                        cartaoMesValidade: 0,
                        cartaoAnoValidade: 0,
                    }))
            } else {
                const planoAssinaturaOpcaoPagamentoID = formState?.planoAssinaturaOpcaoPagamentoID
                const cartaoNumero = formState?.numeroCartao
                const cartaoCodigo = formState?.codigoCartao
                const cartaoNome = formState?.nomeTitular
                const cartaoDataNascimento = dataNascimento
                const cartaoTelefone = dadosCadastro?.pick.telefoneComercial
                const cartaoMesValidade = formState?.mesCartao
                const cartaoAnoValidade = formState?.anoCartao
                const parcelas = formState?.parcelas

                dispatch(trocarPlano({
                    assinaturaID,
                    planoAssinaturaOpcaoPagamentoID,
                    cartaoNumero,
                    cartaoCodigo,
                    cartaoNome,
                    cartaoDataNascimento,
                    cartaoTelefone,
                    cartaoMesValidade,
                    cartaoAnoValidade,
                    parcelas
                }))
            }
        }
        cupom && (dadosFinais.cupomDesconto = cupom)

        dispatch(salvarPlanoAction(formaPagamentoAtual))
        if (assinaturaTransacaoIDStore) dispatch(enviarAssinaturaTransacaoID({
            dadosFinais,
            tipoPagamento: idPagamento === ID_GATEWAY ? 'cartao' : idPagamento === ID_GATEWAY_PIX ? 'pix' : null,
        }))
        if (!assinaturaTransacaoIDStore && !assinaturaID) dispatch(enviarDadosAction(dadosFinais))
    }

    const textFieldStyles = {
        '& label.Mui-focused': {
            color: '#FF9F0D',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#FF9F0D',
            },
            '&:hover fieldset': {
                borderColor: '#FF9F0D',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#FF9F0D',
            },
        },
    };

    const [dadosPagamento, setDadosPagamento] = useState(formaPagamentoAtual);

    useEffect(() => {
        if (cupomInfo?.data?.valorFinal) {
            console.log('cupomInfo', cupomInfo);
            setDadosPagamento({
                ...formaPagamentoAtual,
                valorFinal: cupomInfo.data.valorFinal,
                valorOriginal: cupomInfo.data.valorOriginal,
                desconto: cupomInfo.data.desconto,
            });
        } else {
            console.log('formaPagamentoAtual', formaPagamentoAtual);
            setDadosPagamento(formaPagamentoAtual);
        }
    }, [cupomInfo, formaPagamentoAtual]);


    return (
        <Container maxWidth="lg" sx={{ mt: 1 }}>
            <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                <Grid item ml={3} mt={.5}>
                    {!assinaturaTransacaoIDStore && <ButtonReturn text="Voltar para Assinatura" />}
                </Grid>
                <Grid item xs={12} textAlign="center">
                    <Typography variant="h4" sx={{ color: '#000', fontWeight: 'bold', mt: 2 }}>
                        {planoSelecionado?.nome?.toUpperCase() || 'PLANO'}
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#A4A4A4', mb: 2, fontWeight: 'bold', fontSize: '16px' }}>
                        Preencha todas as informações de pagamento
                    </Typography>
                </Grid>
                <Grid item xs={1} sm={2}></Grid> {/* Espaço para manter o alinhamento */}
            </Grid>
            <CustomizedSteppers activeStep={2} />
            <Typography variant="h6" fontWeight={'500'} gutterBottom>Forma de pagamento</Typography>
            <RadioGroup
                sx={{ marginBottom: 2 }}
                color='primary'
                row
                onChange={handleMetodoPagamento}
                value={idPagamento}
            >
                {radioFormasPagamento.temCartao && (
                    <FormControlLabel
                        control={<Radio sx={{ color: '#E8E8E8', '&.Mui-checked': { color: '#FF9F0D' }, }} />}
                        value={ID_GATEWAY}
                        label={"Cartão"}
                    />
                )}
                {radioFormasPagamento.temPix && (cupomInfo?.data?.cupomDesconto?.quantidadeDiasGratis < 1 || !cupomInfo?.data?.cupomDesconto?.quantidadeDiasGratis) && (
                    <FormControlLabel
                        control={<Radio sx={{ color: '#E8E8E8', '&.Mui-checked': { color: '#FF9F0D' }, }} />}
                        value={ID_GATEWAY_PIX}
                        label={"Pix"}
                    />
                )}
            </RadioGroup>

            {idPagamento === ID_GATEWAY && (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6" fontWeight={'500'} gutterBottom>
                            Informações do Cartão
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} >
                        <TextField
                            fullWidth
                            label="Número do Cartão"
                            name='numeroCartao'
                            variant="outlined"
                            sx={textFieldStyles}
                            value={formState.numeroCartao}
                            onChange={handleCardNumberChange}
                            onBlur={handleBlur}
                            error={numeroCartaoError}
                            helperText={numeroCartaoError && 'Número inválido'}
                            inputProps={{ maxLength: 19 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} >
                        <TextField
                            fullWidth
                            label="Nome do Titular"
                            name='nomeTitular'
                            variant="outlined"
                            sx={textFieldStyles}
                            value={formState.nomeTitular}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={nomeTitularError}
                            helperText={nomeTitularError && 'Nome inválido'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} >
                        <TextField
                            fullWidth
                            label="CVV"
                            name="codigoCartao"
                            variant="outlined"
                            sx={textFieldStyles}
                            onBlur={handleBlur}
                            error={codigoCartaoError}
                            helperText={codigoCartaoError && 'CVV inválido'}
                            value={formState.codigoCartao}
                            onChange={handleFormState}
                            inputProps={{ maxLength: 3 }}
                            autoComplete='off'
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            sx={{
                                ...textFieldStyles,
                                '& input': {
                                    opacity: formState.dataNascimento !== '' || dateFocused ? 1 : 0,
                                    transition: 'opacity 0.3s',
                                }
                            }}
                            type="date"
                            label="Data de Nascimento"
                            name="dataNascimento"
                            error={dataNascimentoError}
                            helperText={dataNascimentoError && 'Data inválida'}
                            value={formState.dataNascimento}
                            onChange={handleDataNascimentoChange}
                            onBlur={(e) => {
                                handleBlur(e)
                                setDateFocused(false)
                            }}
                            onFocus={() => setDateFocused(true)}
                            inputProps={{
                                min: "1900-01-01",
                                max: new Date().toISOString().slice(0, 10),
                                autoComplete: "off",
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} >
                        <TextField
                            select
                            fullWidth
                            label="Mês de Validade"
                            name='mesCartao'
                            variant="outlined"
                            sx={textFieldStyles}
                            value={mesesDoAno.indexOf(mesSelecionado) === -1 ? '' : mesesDoAno.indexOf(mesSelecionado)}
                            onChange={(e) => setMesSelecionado(mesesDoAno[e.target.value])}
                            onBlur={handleBlur}
                            error={mesCartaoError}
                            helperText={mesCartaoError && 'Mês inválido'}
                        >
                            <MenuItem value="" disabled>Selecione uma opção</MenuItem>
                            {mesesDoAno.map((mes, index) => (
                                <MenuItem key={mes} value={index}>
                                    {`${mes} (${index + 1})`}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} >
                        <TextField
                            fullWidth
                            label="Ano de Validade"
                            placeholder='YYYY'
                            variant="outlined"
                            name='anoCartao'
                            sx={textFieldStyles}
                            value={formState.anoCartao}
                            onChange={handleFormState}
                            onBlur={handleBlur}
                            error={anoCartaoError}
                            helperText={anoCartaoError && 'Ano inválido'}
                            inputProps={{ maxLength: 4 }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} >
                        <TextField
                            select
                            fullWidth
                            label="Parcelas"
                            variant="outlined"
                            sx={textFieldStyles}
                            value={formaPagamentoAtual.planoAssinaturaOpcaoPagamentoID}
                            onChange={handleParcelas}
                        >
                            {arrayParcelas.map(parcela => (
                                <MenuItem key={parcela.planoAssinaturaOpcaoPagamentoID} value={parcela.planoAssinaturaOpcaoPagamentoID}>
                                    {(parcela.numeroParcelas === 1) ? `${parcela.numeroParcelas} Parcela` : `${parcela.numeroParcelas} parcelas`}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            )}

            <Typography
                variant="p"
                sx={{
                    display: 'block',
                    color: '#000000',
                    fontSize: '1rem',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    margin: '1rem 0 .5rem',
                }}
            >
                Total
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    color: '#A4A4A4',
                    mx: '5px',
                    fontSize: '1.3rem',
                    textDecoration: 'line-through',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                }}
            >
                {dadosPagamento.desconto ? `(${formatValor(dadosPagamento?.valorOriginal)} ${formatValor(dadosPagamento?.desconto)})` : ""}
            </Typography>

            {cupomInfo?.data?.cupomDesconto?.quantidadeDiasGratis > 0 && <Typography>
                O valor será cobrado no seu cartão somente após os {cupomInfo?.data?.cupomDesconto?.quantidadeDiasGratis} dias!
            </Typography>}
            {/* Exibição do valor final com base no método de pagamento */}
            {idPagamento === ID_GATEWAY ? (
                <Box>
                    <Typography
                        variant="body1"
                        sx={{
                            display: 'block',
                            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                            fontSize: '1rem',
                            color: '#A4A4A4',
                        }}
                    >
                        {dadosPagamento?.numeroParcelas} x{' '}
                        <Typography
                            component="span"
                            sx={{
                                color: '#FF9F0D',
                                ml: '5px',
                                fontSize: '1.5rem',
                            }}
                        >
                            {formatValor(dadosPagamento?.valorOriginal / dadosPagamento?.numeroParcelas)}
                        </Typography>
                    </Typography>
                </Box>
            ) : idPagamento === ID_GATEWAY_PIX ? (
                <Typography
                    variant="h6"
                    sx={{
                        color: '#FF9F0D',
                        fontSize: '1.5rem',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    }}
                >
                    {formatValor(dadosPagamento?.valorFinal)}
                </Typography>
            ) : (
                <AlertError
                    message="Método de Pagamento Não Cadastrado e/ou Inválido, por favor, entre em contato com o Suporte."
                    margin="20px 0 0 0"
                />
            )}

            {/* Exibição de alertas */}
            {openAlert && (
                <AlertError
                    message={messageAlert}
                    onClose={() => setOpenAlert(false)}
                    margin="20px 0 0 0"
                />
            )}
            <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={9} sm={6} md={4} >
                    <Button
                        onClick={handleClickPagar}
                        variant="contained"
                        fullWidth
                        sx={{
                            mt: 3,
                            backgroundColor: '#FF9F0D',
                            '&:hover': { backgroundColor: '#e68a00' },
                            borderRadius: '10px',
                            margin: '20px auto 40px',
                            display: 'block',
                            fontWeight: '700',
                            padding: '.5rem',
                            fontSize: '.875rem'
                        }}
                        disabled={!prosseguir || loading}
                    >
                        {loading ? <CircularProgress size={'.875rem'} color="inherit" /> : 'Pagar'}
                    </Button>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Pagamento;
